import React, { useContext, useEffect } from 'react';
import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import ListItemButton from '@mui/material/ListItemButton';
import { wordList } from './api'
import { useNavigate } from 'react-router-dom'; // 改为使用 useNavigate
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';

export default function WordList() {
    const navigate = useNavigate();
    const [pageWordList, setPageWordList] = React.useState([])
    const getPageWordList = async () => {
        try {
            const result = await wordList();
            setPageWordList(result.dataList);
            console.log(result);
        } catch (err) {
            console.log("加载word list出错:", err);
        }
    };

    useEffect(() => {
        getPageWordList();
    }, [])

    return (

        <Grid container sx={{ justifyContent: 'center' }}>
            <Grid container sx={{ justifyContent: 'center' }}>
                <Grid item>
                    <Tooltip disableHoverListener title="Add">
                        <Button onClick={() => {
                            navigate('/wordEdit');
                        }}>Add New Word</Button>
                    </Tooltip>
                </Grid>
            </Grid>
            <List
                sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
                component="nav"
                aria-labelledby="nested-list-subheader"
                subheader={
                    <ListSubheader component="div" id="nested-list-subheader">
                        单词本
                    </ListSubheader>
                }
            >
                {pageWordList.map(({ word, id, createdTime }) => (
                    <WordItem id={id} primary={word} secondary={createdTime} navigate={navigate}></WordItem>
                ))}
            </List>
        </Grid>
    );
}

function WordItem({ id, primary, secondary, navigate }) {
    return (
        <ListItemButton
            onClick={() => {
                const wordDetailId = id;
                navigate('/wordEdit', { state: { wordDetailId } });
                console.log("id: " + id); // 直接使用 id
            }}
        >
            <ListItemText id={id} primary={primary} secondary={secondary} />
        </ListItemButton>
    );
}